import sortBy from "lodash.sortby";
import { IKeyFigure } from "src/api/server/extended-search";
import { IKeyFigureValue } from "../components/types";
import { getKeyFigureMinAndMaxByKeyFigureId } from "./get-key-figure-min-and-max-by-key-figure-id";
import { getUrlIdentifier } from "./get-url-identifier";

const MIN_QUERY_PARAM_NAME = "min";
const MAX_QUERY_PARAM_NAME = "max";

export const mapKeyFiguresFromQuery = (urlParams: URLSearchParams, keyFigures: readonly IKeyFigure[]): IKeyFigureValue[] => {
    const result: IKeyFigureValue[] = [];

    for (const keyFigure of keyFigures) {
        const keyFigureValue = urlParams.get(keyFigure.urlIdentifier);
        const keyFigureFound = keyFigureValue !== null && keyFigureValue.includes(";");
        if (keyFigureFound) {
            let minimum = Number.parseFloat(keyFigureValue.split(";")[0]);
            let maximum = Number.parseFloat(keyFigureValue.split(";")[1]);

            const defaultMinimum = keyFigure.steps[0];
            const defaultMaximum = keyFigure.steps[keyFigure.steps.length - 1];

            if (minimum < defaultMinimum) {
                minimum = defaultMinimum;
            }

            if (maximum > defaultMaximum) {
                maximum = defaultMaximum;
            }

            if (minimum > maximum) {
                [minimum, maximum] = [maximum, minimum];
            }
            result.push({
                id: keyFigure.id,
                min: Number.isNaN(minimum) ? undefined : minimum,
                max: Number.isNaN(maximum) ? undefined : maximum,
                isPopular: keyFigure.isPopular,
            });
        }
    }

    return result;
};

export const mapKeyFiguresToQuery = (keyFigures: readonly IKeyFigureValue[], keyFiguresData: readonly IKeyFigure[]) => {
    const selectedKeyFigures = [];

    if (keyFigures?.length > 0) {
        for (const selectedKeyFigure of keyFigures) {
            const selectedKeyFigureUrlIdentifier = getUrlIdentifier(keyFiguresData, selectedKeyFigure.id);
            if (selectedKeyFigureUrlIdentifier) {
                const { defaultMinimum, defaultMaximum } = getKeyFigureMinAndMaxByKeyFigureId(selectedKeyFigure.id, keyFiguresData);
                if (selectedKeyFigure.min !== defaultMinimum || selectedKeyFigure.max !== defaultMaximum) {
                    selectedKeyFigures.push({
                        urlIdentifier: selectedKeyFigureUrlIdentifier,
                        min: selectedKeyFigure.min ?? MIN_QUERY_PARAM_NAME,
                        max: selectedKeyFigure.max ?? MAX_QUERY_PARAM_NAME,
                    });
                }
            }
        }
    }

    const sortedSelectedKeyFigures = sortBy(selectedKeyFigures, keyFigure => keyFigure.urlIdentifier);
    return sortedSelectedKeyFigures.map(keyFigure => `${keyFigure.urlIdentifier}=${keyFigure.min};${keyFigure.max}`).join("&");
};
